import useTasks from '@modules/TasksModule/hooks/useTasks';

const TasksPanel = () => {
  const tasks = useTasks();
  return (
    <div>
      <pre>{JSON.stringify(tasks, undefined, 2)}</pre>
    </div>
  );
};

export default TasksPanel;
